import React from "react";
import Header from "../components/FrontPage/Header/Header";
import Footer from "../components/Footer2/Footer";
import LeftDrawer from "../components/Dashboard/Drawers/LeftDrawer";
import DRIP from "./static/DRIP";
import ScrollToTopOnMount from "../helpers/ScrollToTop";

const LoadUploadPage = ({ USER }) => {
  return (
    <>
      <ScrollToTopOnMount />
      <Header landingPage={true} />
      <DRIP />
      <Footer />
      {USER && <LeftDrawer small />}
    </>
  );
};

export default LoadUploadPage;
